import dayjs from '../../Utils/dayjs';

export type MediaLoop = {
  tag?: string;
  startTime: string;
  endTime: string;
  loopCount: number;
  dynamicLoopCount: boolean;
};

// Utility functions
function timeToSeconds(time: string): number {
  const split = time.split(':').reverse();
  const seconds = split.length > 0 ? Number(split[0]) : 0;
  const minutes = split.length > 1 ? Number(split[1]) : 0;
  const hours = split.length > 2 ? Number(split[2]) : 0;
  return hours * 3600 + minutes * 60 + seconds;
}

function secondsToTime(videoSeconds: number): string {
  const duration = dayjs.duration(videoSeconds, 'seconds');
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();
  const milliseconds = duration.milliseconds().toFixed(0);
  return `${hours.toString(10).padStart(2, '0')}:${minutes.toString(10).padStart(2, '0')}:${seconds
    .toString(10)
    .padStart(2, '0')}.${milliseconds.padStart(3, '0')}`;
}

export function getLoopStartSeconds(l: MediaLoop): number {
  return timeToSeconds(l.startTime);
}

export function getLoopEndSeconds(l: MediaLoop): number | undefined {
  return l.endTime ? timeToSeconds(l.endTime) : undefined;
}

export function setLoopStartSeconds(l: MediaLoop, seconds: number): MediaLoop {
  return { ...l, startTime: secondsToTime(seconds) };
}

export function setLoopEndSeconds(l: MediaLoop, seconds: number): MediaLoop {
  return { ...l, endTime: secondsToTime(seconds) };
}

/** @deprecated Use raw object instead */
export function createMediaLoop(json?: Partial<MediaLoop>): MediaLoop {
  return {
    startTime: json?.startTime ?? '00:00:00.000',
    endTime: json?.endTime ?? '00:00:00.000',
    tag: json?.tag,
    loopCount: json?.loopCount ?? -1,
    dynamicLoopCount: json?.dynamicLoopCount ?? false,
  };
}

// For backwards compatibility - static utility
export const MediaLoopUtils = {
  calculateTime: secondsToTime,
};
